exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-task-title[data-v-0be0b6f0]{color:#303030;font-size:14px}.admin-task-subtitle[data-v-0be0b6f0],.admin-task-title[data-v-0be0b6f0]{font-family:Open Sans,sans-serif;letter-spacing:0;line-height:22px}.admin-task-subtitle[data-v-0be0b6f0]{display:flex;color:#8997aa;font-size:12px}.admin-task-time[data-v-0be0b6f0]{color:#8997aa;font-family:Open Sans,sans-serif;font-size:14px;font-weight:600;letter-spacing:0;line-height:19px;text-align:right}", ""]);

// exports
